import type { CRMOpportunity } from '../../types/crm';
import type { Json, Tables } from '../../types/supabase';

const toJsonRecord = (value: Json | null): Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value) ? value : {};

const STATUSES: readonly CRMOpportunity['status'][] = ['open', 'won', 'lost'];
const REVENUE_TYPES: readonly CRMOpportunity['revenue_type'][] = ['recurring', 'one_time', 'mixed'];

/**
 * A raw `crm_opportunities` row as the domain deal (its joins are attached by the reader). An
 * unknown status reads as open, an unknown revenue type as recurring — the columns' defaults.
 * (Four other copies of this mapping remain: PLAN-DETTE.)
 */
export function opportunityFromRow(row: Tables<'crm_opportunities'>): CRMOpportunity {
  const { client_request_id, ...scalars } = row;
  void client_request_id; // the creation's idempotency key, not part of the domain deal
  return {
    ...scalars,
    currency: scalars.currency ?? 'EUR',
    custom_fields: toJsonRecord(scalars.custom_fields),
    is_onboarding: scalars.is_onboarding ?? false,
    status: STATUSES.find((s) => s === scalars.status) ?? 'open',
    revenue_type: REVENUE_TYPES.find((t) => t === scalars.revenue_type) ?? 'recurring',
  };
}
